import React__default from 'react';
import { Spinner } from '../../display/Spinner/Spinner.es.js';
import { LegacyButton } from '../LegacyButton/Button.es.js';

const spinner = "_spinner_3kaqk_1";
const styles = {
	spinner: spinner
};

const LoadMoreBar = (props) => {
  const { children, isLoading, onClick, size } = props;
  const spinner = React__default.createElement(
    "span",
    { className: styles.spinner, "data-zds": true },
    React__default.createElement(Spinner, { color: "dark", "aria-label": "Loading icon" }),
    "Loading"
  );
  return React__default.createElement(LegacyButton, { color: "secondary", disabled: isLoading, isFullWidth: true, onClick, size }, isLoading ? spinner : children);
};

export { LoadMoreBar };
//# sourceMappingURL=LoadMoreBar.es.js.map
